import * as React from 'react';
import YadoItemPhotoView from './views/YadoItemPhotoView';
import { IYado } from '../types';

interface IProps {
  yado: IYado,
}

const YadoItemPhoto: React.FC<IProps> = ({ yado }) => {
  const { images, rating } = yado;
  const image = images != null ? images[0] : null;
  return (
    <YadoItemPhotoView style={image ? { backgroundImage: `url(${image})` } : null}>
      {rating && rating > 0 ?
        <div className="rating">
          {rating}
        </div> : null
      }
    </YadoItemPhotoView>
  );
}

export default YadoItemPhoto;
